export const Genders = [
    { value: null, label: '-' },
    { value: 'Female', label: 'Femenino' },
    { value: 'Male', label: 'Masculino' },
    { value: 'Other', label: 'Otro' },
];

export const countriesEnum = {
    AR: 'AR',
    UY: 'UY'
}

export const countries = [
    { value: countriesEnum.AR, label: 'Argentina' },
    { value: countriesEnum.UY, label: 'Uruguay' }
];

export const currenciesEnum = {
    ARS: 'ARS',
    UYU: 'UYU',
    USD: 'USD'
}

export const defaultCurrencyByCountry = {
    AR: currenciesEnum.ARS,
    UY: currenciesEnum.UYU
};

export const currencies = [
    { value: currenciesEnum.ARS, label: 'ARS' },
    { value: currenciesEnum.UYU, label: 'UYU' },
    { value: currenciesEnum.USD, label: 'USD' }
];

export const TaxCondition = [
    { value: 'FinalConsumer', label: 'Consumidor Final' },
    { value: 'RegisteredManager', label: 'Responsable inscripto' },
    { value: 'Exempt', label: 'Exento' },
    { value: 'SingleTaxSystemPayer', label: 'Monotributista' },
    { value: 'ExteriorClient', label: 'Cliente exterior' }
];

export const gender = [
    { value: 'Male', label: 'Masculino' },
    { value: 'Female', label: 'Femenino' },
    { value: 'Other', label: 'Otro' },
];

export const FilterGender = [
    { value: '', label: 'Todos' },
    ...gender
];

export const FilterTaxCondition = [
    { value: '', label: 'Todos' },
    ...TaxCondition
];

export const country = [
    { value: 'AR', label: 'Argentina' },
    { value: 'UY', label: 'Uruguay' }
];

export const FilterCountry = [
    { value: '', label: 'Todos' },
    ...country
];

export const InvoiceType = {
    FA: 'FA',
    FB: 'FB',
    ETicket: 'ETicket',
    EFactura: 'EFactura'
}

export const InvoiceTypeFormat = {
    FA: 'Factura A',
    FB: 'Factura B',
    ETicket: 'E-Ticket',
    EFactura: 'E-Factura'
}

export const InvoiceTypeSelect = [
    { label: InvoiceTypeFormat.FA, value: InvoiceType.FA, country: 'AR' },
    { label: InvoiceTypeFormat.FB, value: InvoiceType.FB, country: 'AR' },
    { label: InvoiceTypeFormat.ETicket, value: InvoiceType.ETicket, country: 'UY' },
    { label: InvoiceTypeFormat.EFactura, value: InvoiceType.EFactura, country: 'UY' }
]

export const InvoicePaymentMethods = {
    Cash: 'Cash',
    Card: 'Card',
    ChargeByBank: 'ChargeByBank',
    Qr: 'Qr',
    Link: 'Link',
    Check: 'Check',
    Transfer: 'Transfer',
    GOcuotas: 'GOcuotas',
    TerminalQr: 'TerminalQr'
}

export const InvoicePaymentMethodsFormat = {
    Cash: 'Efectivo',
    Card: 'Tarjeta',
    ChargeByBank: 'Transferencia Bancaria',
    Qr: 'Mercado Pago QR',
    Link: 'Mercado Pago',
    Check: 'Cheque',
    Transfer: 'Transferencia',
    GOcuotas: 'GO Cuotas',
    TerminalQr: 'Terminal QR'
}

export const InvoicePaymentMethodsSelect = [
    { label: InvoicePaymentMethodsFormat.Cash, value: InvoicePaymentMethods.Cash },
    { label: InvoicePaymentMethodsFormat.Card, value: InvoicePaymentMethods.Card },
    { label: InvoicePaymentMethodsFormat.ChargeByBank, value: InvoicePaymentMethods.ChargeByBank },
    { label: InvoicePaymentMethodsFormat.Qr, value: InvoicePaymentMethods.Qr },
    { label: InvoicePaymentMethodsFormat.Link, value: InvoicePaymentMethods.Link },
    { label: InvoicePaymentMethodsFormat.Check, value: InvoicePaymentMethods.Check },
    { label: InvoicePaymentMethodsFormat.Transfer, value: InvoicePaymentMethods.Transfer },
    { label: InvoicePaymentMethodsFormat.GOcuotas, value: InvoicePaymentMethods.GOcuotas },
    { label: InvoicePaymentMethodsFormat.TerminalQr, value: InvoicePaymentMethods.TerminalQr },
]

export const TaxConditionType = {
    FinalConsumer: 'FinalConsumer',
    RegisteredManager: 'RegisteredManager',
    Exempt: 'Exempt',
    SingleTaxSystemPayer: 'SingleTaxSystemPayer',
    ExteriorClient: 'ExteriorClient'
}

export const SelectConditionTypes = [
    { label: 'Consumidor Final', value: TaxConditionType.FinalConsumer, country: 'AR' },
    { label: 'Responsable inscripto', value: TaxConditionType.RegisteredManager, country: 'AR' },
    { label: 'Exento', value: TaxConditionType.Exempt, country: 'AR' },
    { label: 'Monotributista', value: TaxConditionType.SingleTaxSystemPayer, country: 'AR' },
    { label: 'Cliente exterior', value: TaxConditionType.ExteriorClient, country: 'AR' },
    { label: 'Consumidor Final', value: TaxConditionType.FinalConsumer, country: 'UY' },
    { label: 'Cliente exterior', value: TaxConditionType.ExteriorClient, country: 'UY' },
    { label: 'Responsable inscripto', value: TaxConditionType.RegisteredManager, country: 'UY' },
];

export const GetConditionTypeByCountry = (operationCountry = '') => {
    return SelectConditionTypes
        .filter(type => !type.country || type.country === operationCountry);
}

export const DocumentType = {
    DNI: 'DNI',
    CI: 'CI',
    CUIT: 'CUIT',
    RUT: 'RUT',
    Passport: 'Passport',
    CedulaURY: 'CedulaURY',
    OTHER: 'Other'
}

export const SelectDocumentTypes = [
    { value: DocumentType.DNI, label: DocumentType.DNI, country: 'AR' },
    { value: DocumentType.CUIT, label: DocumentType.CUIT, country: 'AR' },
    { value: DocumentType.CI, label: DocumentType.CI, country: 'UY' },
    { value: DocumentType.RUT, label: DocumentType.RUT, country: 'UY' },
    { value: DocumentType.Passport, label: 'Pasaporte', country: 'AR', isForAll: true, acceptCharacters: true },
    { value: DocumentType.OTHER, label: 'Otro', country: 'UY', isForAll: true, acceptCharacters: true }
];

export const FilterdocumentTypes = [
    { value: '', label: 'Todos' },
    { value: DocumentType.DNI, label: DocumentType.DNI },
    { value: DocumentType.CI, label: DocumentType.CI },
    { value: DocumentType.CUIT, label: DocumentType.CUIT },
    { value: DocumentType.LC, label: DocumentType.LC },
    { value: DocumentType.RUT, label: DocumentType.RUT },
    { value: 'CedulaURY', label: 'Cedula URY' },
    { value: DocumentType.Passport, label: 'Pasaporte' },
    { value: DocumentType.OTHER, label: 'Otro' }
];

export const GetDocumentType = (operationCountry = '', country = '') => {
    if ((operationCountry === 'AR' && country !== 'AR') || (operationCountry === 'UY' && country !== 'UY'))
        return SelectDocumentTypes
            .filter(type => type.isForAll)
            .filter(type => type.country === operationCountry);

    return SelectDocumentTypes
        .filter(type => !type.isForAll)
        .filter(type => type.country === operationCountry);
}

export const GetDocumentTypeByCountry = (operationCountry = '') => {
    return SelectDocumentTypes
        .filter(type => !type.country || type.country === operationCountry);
}

export const GetInvoiceTypeByCountry = (country = '') =>
    InvoiceTypeSelect.filter(type => type.country === country);

export const VoucherType = {
    CreditNoteA: 'CreditNoteA',
    CreditNoteB: 'CreditNoteB',
    CreditNoteETicket: 'CreditNoteETicket',
    CreditNoteEFactura: 'CreditNoteEFactura'
}

export const VoucherTypeFormat = {
    CreditNoteA: 'Nota crédito A',
    CreditNoteB: 'Nota crédito B',
    CreditNoteETicket: 'Nota crédito E-Ticket',
    CreditNoteEFactura: 'Nota crédito E-Factura'
}

export const VoucherTypeSelect = [
    { label: VoucherTypeFormat.CreditNoteA, value: VoucherType.CreditNoteA, country: 'AR' },
    { label: VoucherTypeFormat.CreditNoteB, value: VoucherType.CreditNoteB, country: 'AR' },
    { label: VoucherTypeFormat.CreditNoteETicket, value: VoucherType.CreditNoteETicket, country: 'UY' },
    { label: VoucherTypeFormat.CreditNoteEFactura, value: VoucherType.CreditNoteEFactura, country: 'UY' },
]

export const GetVoucherTypeByCountry = (country = '') =>
    VoucherTypeSelect.filter(type => type.country === country);

export const GetTaxCondition = (documentType = '') => {
    switch (documentType) {
        case DocumentType.DNI:
        case DocumentType.LC:
        case DocumentType.LE:
        case DocumentType.CI:
            return TaxCondition.filter(tax => tax.value === TaxConditionType.FinalConsumer);
        case DocumentType.CUIT:
            return TaxCondition
                .filter(tax =>
                    tax.value === TaxConditionType.RegisteredManager ||
                    tax.value === TaxConditionType.Exempt ||
                    tax.value === TaxConditionType.SingleTaxSystemPayer
                )
        case DocumentType.RUT:
            return TaxCondition
                .filter(tax => tax.value === TaxConditionType.RegisteredManager);
        case DocumentType.Passport:
            return TaxCondition
                .filter(tax => tax.value === TaxConditionType.ExteriorClient);
        case DocumentType.OTHER:
            return TaxCondition
                .filter(tax =>
                    tax.value === TaxConditionType.ExteriorClient ||
                    tax.value === TaxConditionType.FinalConsumer);
        default:
            return TaxCondition;
    }
}

export const GetTaxConditionLabel = (taxCondition) => {
    const item = TaxCondition.find(t => t.value === taxCondition);
    return item ? item.label : '';
}

export const DocumentTextHelp = (documentType = '') => {
    switch (documentType) {
        case DocumentType.CI:
            return 'CI: xxxxxxxx (7 a 9 digitos)';
        case DocumentType.RUT:
            return 'RUT: xxxxxxxxxxx (21 digitos)';
        case DocumentType.Passport:
        case DocumentType.OTHER:
            return 'Pasaporte: xxxxxxxx (numeros y letras)';
        case DocumentType.DNI:
            return 'DNI: xxxxxxxx (7 a 9 digitos)';
        case DocumentType.CUIT:
        default:
            return 'CUIT: xxxxxxxxxxx (11 digitos)';
    }
}

export const booleanTranslate = {
    false: 'No',
    true: 'Sí',
}

export const booleanTypes = {
    false: false,
    true: true,
}

export const booleanSelected = [
    { value: booleanTypes.true, label: booleanTranslate.true },
    { value: booleanTypes.false, label: booleanTranslate.false }
]

export const booleanFilter = [
    { value: null, label: 'Todos' },
    ...booleanSelected
]

export const FloorDepartment = [
    { value: "PB", label: 'Planta baja' },
    { value: "1", label: '1' },
    { value: "2", label: '2' },
    { value: "3", label: '3' },
    { value: "4", label: '4' },
    { value: "5", label: '5' },
    { value: "6", label: '6' },
    { value: "7", label: '7' },
    { value: "8", label: '8' },
    { value: "9", label: '9' },
    { value: "10", label: '10' },
    { value: "11", label: '11' },
    { value: "12", label: '12' },
    { value: "13", label: '13' },
    { value: "14", label: '14' },
    { value: "15", label: '15' },
    { value: "16", label: '16' },
    { value: "17", label: '17' },
    { value: "18", label: '18' },
    { value: "19", label: '19' },
    { value: "20", label: '20' },
    { value: "21", label: '21' },
    { value: "22", label: '22' },
    { value: "23", label: '23' },
    { value: "24", label: '24' },
    { value: "25", label: '25' },
    { value: "26", label: '26' },
    { value: "27", label: '27' },
    { value: "28", label: '28' },
    { value: "29", label: '29' },
    { value: "30", label: '30' }
];
export const AddressDepartment = [
    { value: "1", label: '1' },
    { value: "2", label: '2' },
    { value: "3", label: '3' },
    { value: "4", label: '4' },
    { value: "5", label: '5' },
    { value: "6", label: '6' },
    { value: "7", label: '7' },
    { value: "8", label: '8' },
    { value: "A", label: 'A' },
    { value: "B", label: 'B' },
    { value: "C", label: 'C' },
    { value: "D", label: 'D' },
    { value: "E", label: 'E' },
    { value: "F", label: 'F' },
    { value: "G", label: 'G' },
    { value: "H", label: 'H' }
];